import Controller from '@ember/controller';
import {
  computed,
  get,
  getProperties,
  set,
  setProperties,
} from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import { task } from 'ember-concurrency';

export default Controller.extend({
  router: service(),
  store: service(),

  error: null,

  reset() {
    setProperties(this, {
      error: null,
    });
  },

  templateOptions: computed('model.templates.@each.id', function () {
    return [''].concat(
      sortByProperties(
        get(this, 'model.templates').map((x) => {
          return { label: get(x, 'name'), val: get(x, 'id') };
        }),
        ['label'],
      ),
    );
  }),

  selectedTemplate: computed('model.changeset.templateId', function () {
    let selectedTemplateId = get(this, 'model.changeset.templateId');
    return get(this, 'model.templates').find(
      (x) => get(x, 'id') === selectedTemplateId,
    );
  }),

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      try {
        let selectedTemplate = this.selectedTemplate;
        let copiedProperties = Object.assign(
          {
            name: get(this, 'model.changeset.name'),
            fromTemplateId: get(selectedTemplate, 'id'),
          },
          getProperties(
            selectedTemplate,
            'frequencyTimespan',
            'frequencyNumber',
            'staticInfo',
            'sections',
          ),
        );

        // remove values from staticInfo
        (get(copiedProperties, 'staticInfo') || []).forEach((info) => {
          info.v = null;
        });
        // remove overall goals
        get(copiedProperties, 'sections').forEach((section) => {
          get(section, 'fields').forEach((field) => {
            if (!isEmpty(field.overallGoal)) {
              delete field.overallGoal;
              delete field.intervalGoal;
            }
          });
        });

        let record = this.store.createRecord(
          'coaching/individual',
          copiedProperties,
        );
        yield record.save();
        this.router.transitionTo(
          'coaching.individuals.individual.edit',
          get(record, 'id'),
        );
      } catch (error) {
        set(this, 'error', error);
      }
    }
  }).drop(),
});
